import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface IncTxInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function IncTxInternalControls({ onBack, setActiveSection, controlsListSection }: IncTxInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Income Tax"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}



